import { Divider } from '@chakra-ui/react';
import {
  Benefits,
  ComparisonTable,
  Facts,
  PressMarquee,
  QuoteCarousel,
} from '@time-line/components/blocks';
import { HeroCarousel } from '@time-line/components/common';
import { ScientificResearchDrawer } from '@time-line/components/drawers';
import { PageWrapper } from 'components/common/PageWrapper';
import { RichTextResolver } from 'components/common/RichTextResolver';
import { Seo } from 'components/common/Seo';
import { BlogCardCarousel } from 'components/sections/BlogCardCarousel';
import { ProductCarouselWrapper } from 'components/sections/ProductCardCarousel/ProductCarouselWrapper';
import { ReviewsCarousel } from 'components/sections/ReviewsCarousel';
import { WallOfLove } from 'components/sections/WallOfLove';
import { useHome } from 'hooks/pages/useHome';
import { useRatingsOverview } from 'hooks/reviews/useRatingsOverview';
import { SHOP } from 'lib/constants/navigation';
import { STUDIES } from 'lib/constants/routes';
import { addReviewsToOverline } from 'utils/addReviewsToOverline';

export const Home = () => {
  const { data: home } = useHome();
  const { data: ratingsOverview } = useRatingsOverview();

  const {
    seo,
    heroCarousel,
    reviewsCarousel,
    facts,
    benefitsV2,
    comparisonTable,
    productCarousel,
    pressQuotes,
    wallOfLove,
    quoteCarousel,
    blogCarousel,
  } = home;

  const modifiedHeroCarousel = heroCarousel.map((item) => ({
    ...item,
    overline: addReviewsToOverline(item.overline, ratingsOverview),
  }));

  return (
    <PageWrapper>
      <Seo seo={seo} />

      {heroCarousel && (
        <HeroCarousel items={modifiedHeroCarousel} isDoctorRecommended />
      )}

      <ReviewsCarousel {...reviewsCarousel} />

      {facts && (
        <Facts
          {...facts}
          RichTextResolver={RichTextResolver}
          drawerInner={
            <ScientificResearchDrawer
              cta={{ href: STUDIES, title: 'Our Studies' }}
            />
          }
        />
      )}

      {benefitsV2 && (
        <Benefits RichTextResolver={RichTextResolver} {...benefitsV2} />
      )}

      {comparisonTable && (
        <ComparisonTable
          {...comparisonTable}
          richTextResolver={RichTextResolver}
        />
      )}

      {productCarousel && (
        <ProductCarouselWrapper
          fallbackCta={{ title: SHOP.label, href: SHOP.href }}
          productCarousel={productCarousel}
        />
      )}

      {pressQuotes && <PressMarquee {...pressQuotes} />}

      {wallOfLove && <WallOfLove {...wallOfLove} />}

      {quoteCarousel && <QuoteCarousel {...quoteCarousel} />}

      <Divider borderColor="blackAlpha.250" opacity={1} my="m" />

      {blogCarousel && <BlogCardCarousel {...blogCarousel} />}
    </PageWrapper>
  );
};
